import Vue from "vue";
import moment from "moment";
import noimage from "../assets/noimage.png";
/* eslint-disable */
Vue.mixin({
  methods: {
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      }

      return link;
    },
    checkTimeInRange(start, end) {
      const programStart = this.convertTimestamp(start);
      const programEnd = this.convertTimestamp(end);
      const current = this.convertTimestamp(new Date());
      if (programStart >= current || current <= programEnd) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentEpgDesc(start, end) {
      const programStart = this.convertTimestamp(start);
      const programEnd = this.convertTimestamp(end);
      const current = this.convertTimestamp(new Date());

      if (current >= programStart && current <= programEnd) {
        return true;
      } else {
        return false;
      }
    },
    getTodaysDate(str) {
      let formatted;

      if (str == "today") {
        formatted = new Date();
      } else {
        formatted = new Date(+new Date() + 86400000);
      }

      const yyyy = formatted.getFullYear();
      let mm = formatted.getMonth() + 1; // Months start at 0!
      let dd = formatted.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const formattedstr = yyyy + "-" + mm + "-" + dd;
      return formattedstr;
    },
    convertTimestamp(time) {
      var date = new Date(time);
      return date.getTime();
    },
    timeConverter(str) {
      var local_date = moment(str).format("HH:mm");
      return local_date;
    },
    getTimeZone() {
      var offset = new Date().getTimezoneOffset();
      var o = Math.abs(offset);
      // console.log(o);
      return (
        (offset < 0 ? "+" : "-") +
        ("00" + Math.floor(o / 60)).slice(-2) +
        ":" +
        ("00" + (o % 60)).slice(-2)
      );
    },
    formatTimestamp(dt) {
      // gap is 2 weeks from available date
      var result;
      var t = new Date(dt);
      var dtplustwo =
        t.getFullYear() +
        "-" +
        (t.getMonth() + 1) +
        "-" +
        (t.getDate() + 2) +
        " 00:00";
      dtplustwo = new Date(dtplustwo).getTime();
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " 00:00";

      var from = new Date(date).getTime(); //today

      // var twodays =
      //   today.getFullYear() +
      //   "-" +
      //   (today.getMonth() + 1) +
      //   "-" +
      //   (today.getDate() + 5) +
      //   " 00:00";
      // var twodaysafter = new Date(twodays).getTime(); //twodaysfromtodaay
      var twoWeeksAfter = t.setDate(t.getDate() + 14);

      if (from <= twoWeeksAfter) {
        result = true;
      } else {
        result = false;
      }

      return result;
    },
    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },

    // v1
    rtmImgLinkFiltering(item, size, type) {
      // look for specific type first,then do the calculation
      // type -> poster,thumbnail,feature,title

      let img_link;
      let img_size = size ? size : "320x0";
      const img_domain = `https://rtm-images.glueapi.io`;
      var checkThumbnail = item.thumbnail && item.thumbnail.path;
      var checkFeature = item.feature && item.feature.path;
      var checkTitle = item.title && item.title.path;
      var checkPoster = item.poster && item.poster.path;

      if (type) {
        if (type == "poster") {
          if (checkPoster) {
            img_link = `${img_domain}/${img_size}/${item.poster.path}`;
          } else {
            img_link = this.getImageLink(item, size);
            // console.log("testing here", img_link);
          }
        } else if (type == "thumbnail") {
          if (checkThumbnail) {
            img_link = `${img_domain}/${img_size}/${item.thumbnail.path}`;
          } else {
            img_link = this.getImageLink(item, size);
          }
        } else if (type == "feature") {
          if (checkFeature) {
            img_link = `${img_domain}/${img_size}/${item.feature.path}`;
          } else {
            img_link = this.getImageLink(item, size);
          }
        } else if (type == "title") {
          if (checkTitle) {
            img_link = `${img_domain}/${img_size}/${item.title.path}`;
          } else {
            img_link = this.getImageLink(item, size);
          }
        }
      } else {
        img_link = this.getImageLink(item, size);
      }

      return img_link;
    },
    getImageLink(item, size) {
      let img_link;
      let img_size = size ? size : "320x0";
      const img_domain = `https://rtm-images.glueapi.io`;
      var checkThumbnail = item.thumbnail && item.thumbnail.path;
      var checkFeature = item.feature && item.feature.path;
      var checkTitle = item.title && item.title.path;
      var checkPoster = item.poster && item.poster.path;

      if (checkThumbnail) {
        img_link = `${img_domain}/${img_size}/${item.thumbnail.path}`;
      } else {
        if (checkFeature) {
          img_link = `${img_domain}/${img_size}/${item.feature.path}`;
        } else {
          if (checkTitle) {
            img_link = `${img_domain}/${img_size}/${item.title.path}`;
          } else {
            if (checkPoster) {
              img_link = `${img_domain}/${img_size}/${item.poster.path}`;
            } else {
              img_link = noimage;
            }
          }
        }
      }

      return img_link;
    },
    getViewMoreIconPath(iconName) {
      return iconName ? require(iconName) : "";
    },
    convertStringToSmallCaseAndRemovedString(str) {
      return str.replace(/\s+/g, "").toLowerCase();
    },
    lowerCaseAndRemoveSpace(str) {
      return str.replace(/\s+/g, "").toLowerCase();
    },
    getAssetLink(obj) {
      //first check for idSchema
      //change idSchema to type
      // link for vod -> /play/type/programId/episodeID
      // link for TV -> /live/tvId
      // link for radio -> /radio/player/:id?
      let url;

      // console.log(JSON.stringify(obj, null, 2));
      if (obj.idSchema === 2003) {
        url = `/play/movie/${obj.slug}/`;
      } else if (obj.idSchema === 2004) {
        url = `/play/sport/${obj.slug}/`;
      } else if (obj.idSchema === 2005) {
        url = `/play/program/${obj.slug}/`;
      } else if (obj.idSchema === 2006) {
        url = `/play/program/${this.convertStringToSmallCaseAndRemovedString(
          obj.data.program.title
        )}/${obj.slug}/`;
      } else if (obj.idSchema === 2007) {
        url = `/play/news/${obj.slug}/`;
      } else if (obj.idSchema === 2008) {
        url = `/play/news/${this.convertStringToSmallCaseAndRemovedString(
          obj.data.news.title
        )}/${obj.slug}/`;
      } else if (obj.idSchema === 2009) {
        url = `/play/periodic/${obj.slug}/`;
      } else if (obj.idSchema === 2010) {
        url = `/play/periodic/${this.convertStringToSmallCaseAndRemovedString(
          obj.data.periodic.title
        )}/${obj.slug}/`;
      } else if (obj.idSchema === 2001) {
        url = `/live/${obj.slug}`;
      }
      // console.log(url);
      return url;
    },
    getAssetLinkFromFavorite(obj) {
      // console.log("testing in obj", JSON.stringify(obj, null, 2));
      //first check for idSchema
      //change idSchema to type
      // link for vod -> /play/type/programId/episodeID
      // link for TV -> /live/tvId
      // link for radio -> /radio/player/:id?
      let url;

      // console.log(JSON.stringify(obj, null, 2));
      if (obj.content.idSchema === 2003) {
        url = `/play/movie/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2004) {
        url = `/play/sport/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2005) {
        url = `/play/program/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2006) {
        url = `/play/program/${this.convertStringToSmallCaseAndRemovedString(
          obj.data.program.title
        )}/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2007) {
        url = `/play/news/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2008) {
        url = `/play/news/${this.convertStringToSmallCaseAndRemovedString(
          obj.data.news.title
        )}/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2009) {
        url = `/play/periodic/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2010) {
        url = `/play/periodic/${this.convertStringToSmallCaseAndRemovedString(
          obj.data.periodic.title
        )}/${obj.content.slug}/`;
      } else if (obj.content.idSchema === 2001) {
        url = `/live/${obj.content.slug}`;
      }
      // console.log(url);
      return url;
    },
    convertToSlug(str) {
      //replace all special characters | symbols with a space
      str = str
        .replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ")
        .toLowerCase();

      // trim spaces at start and end of string
      str = str.replace(/^\s+|\s+$/gm, "");

      // replace space with dash/hyphen
      str = str.replace(/\s+/g, "-");
      document.getElementById("slug-text").innerHTML = str;
      //return str;
    },
    unslugify(slug) {
      const result = slug;
      return result.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    initializePlayerWithAds(value, target, pageType) {
      // pageType is for page, either live or vod
      const token = localStorage.getItem("token");
      const vidId = parseInt(value);
      let adTagRule;

      if (pageType === "vod") {
        adTagRule = `https://rtm-ads.glueapi.io/vod/vmap.xml?cmsid=${vidId}&url=https://rtm-player.glueapi.io/vod/ad/${vidId}&preroll_pos=/22777916944/RTMKlik_Web_Preroll_VOD&midroll_breaks=2&midroll_pos=/22777916944/RTMKlik_Web_Midroll_VOD&postroll_pos=/22777916944/RTMKlik_Web_Postroll_VOD`;
      } else if (pageType === "berita") {
        adTagRule = `http://rtm-ads.glueapi.io/video/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_BeritaVOD&midroll_pos=/22777916944/RTMKlik_Web_Midroll_BeritaVOD&midroll_breaks=1&postroll_pos=/22777916944/RTMKlik_Web_Postroll_BeritaVOD&cmsid=${vidId}&keywords=&url=https://rtm-player.glueapi.io/vod/ad/${vidId}`;
      }

      const adTag = adTagRule ? adTagRule.replace(/&amp;/g, "&") : "";
      var gluePlayer = new GluePlyr();
      var img = `https://rtm.glueapi.io/v1/content/${vidId}/image/960x540/images.thumbnail`;
      gluePlayer.setup(vidId, {
        apiPath: "https://rtm.glueapi.io",
        svgPath: "https://rtm-player.glueapi.io/latest/includes",
        watermark:
          "https://rtm-images.glueapi.io/filters:quality(100)/200x0/system/rtm-watermark.png",
        target: target,
        poster: img == "0" ? false : img,
        site: "RTM",
        type: "video",
        skin: "0",
        psa: "false",
        debug: true,
        token: token ? token : "",
        ads: {
          enabled: true,
          tagUrl: adTag.replace(/&amp;/g, "&"),
          contentType: "ondemand",
          cmsid: "glue",
          vid: vidId,
          keywords: "",
        },
      });

      window.gluePlayer = gluePlayer;

      this.childDataLoaded = true;
    },

    initializeTVPlayerWithAds(value, target, pageType) {
      // pageType is for page, either live or vod
      const vidId = parseInt(value);
      let adTagRule;

      if (pageType === "live") {
        if (vidId === 1) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_TV1&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=1&keywords=&url=https://rtmklik.rtm.gov.my/live/tv1";
        } else if (vidId === 2) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_TV2&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=2&keywords=&url=https://rtmklik.rtm.gov.my/live/tv2";
        } else if (vidId === 3) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_TVOKEY&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=3&keywords=&url=https://rtmklik.rtm.gov.my/live/okey";
        } else if (vidId === 4) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_SukanRTM&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=4&keywords=&url=https://rtmklik.rtm.gov.my/live/beritartm";
        } else if (vidId === 5) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_SukanRTM&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=4&keywords=&url=https://rtmklik.rtm.gov.my/live/beritartm";
        } else if (vidId === 6) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_TV6&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=6&keywords=&url=https://rtmklik.rtm.gov.my/live/tv6";
        } else if (vidId === 7) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_DewanRakyat&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=7&keywords=&url=https://rtmklik.rtm.gov.my/live/dewanrakyat";
        } else if (vidId === 8) {
          adTagRule =
            "http://rtm-ads.glueapi.io/live/vmap.xml?preroll_pos=/22777916944/RTMKlik_Web_Preroll_Live_DewanNegara&midroll_pos=&midroll_breaks=&postroll_pos=&cmsid=8&keywords=&url=https://rtmklik.rtm.gov.my/live/dewannegara";
        } else {
          adTagRule = "";
        }
      }

      const adTag = adTagRule ? adTagRule.replace(/&amp;/g, "&") : "";
      var gluePlayer = new GluePlyr();
      var img = `https://rtm.glueapi.io/v1/content/${vidId}/image/960x540/images.title`;
      gluePlayer.setup(vidId, {
        apiPath: "https://rtm.glueapi.io",
        svgPath: "https://rtm-player.glueapi.io/latest/includes",
        watermark:
          "https://rtm-images.glueapi.io/filters:quality(100)/200x0/system/rtm-watermark.png",
        target: target,
        poster: img == "0" ? false : img,
        site: "RTM",
        type: "video",
        skin: "0",
        psa: "false",
        debug: true,

        ads: {
          enabled: true,
          tagUrl: adTag.replace(/&amp;/g, "&"),
          contentType: "ondemand",
          cmsid: "glue",
          vid: vidId,
          keywords: "",
        },
      });

      window.gluePlayer = gluePlayer;

      this.childDataLoaded = true;
    },
  },
});
